import { getSystemConnections } from '@Actions/systemConnections';
import { RenderComponentOrLoading, SystemConnectionsTable } from '@Components';
import { useIsSystemConnectionsInitialized } from '@Selectors';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const SystemConnections = () => {
	const dispatch = useDispatch();
	const isSystemConnectionsInitialized = useIsSystemConnectionsInitialized();

	useEffect(() => {
		dispatch(getSystemConnections());
	}, []);

	return (
		<RenderComponentOrLoading loading={!isSystemConnectionsInitialized}>
			<SystemConnectionsTable />
		</RenderComponentOrLoading>
	);
};

export default SystemConnections;
